import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=aa300b36&scoped=true"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"
import style0 from "./newslist.vue?vue&type=style&index=0&id=aa300b36&prod&scoped=true&lang=css"
import style1 from "./newslist.vue?vue&type=style&index=1&id=aa300b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa300b36",
  null
  
)

export default component.exports